import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PlatformLinkTypeView } from "./PlatformLinkTypeView";
import { PlatformLinkTypeViewStore } from "../../store/PlatformLinkTypeViewStore";
import { useStore } from "../../../../hooks";

export const PlatformLinkTypeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/platformLinkType/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PlatformLinkTypeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PlatformLinkTypeView platformLinkTypeViewStore={store} />
      </PageLayout>
    </div>
  );
});
